import { ROUTE_CHANGE } from './redux/constants'

const analytics = () => next => action => {
    console.log('action', action.type)
    window.dataLayer = window.dataLayer || []
    if (action.type === '@@router/LOCATION_CHANGE') {
        window.dataLayer.push({
            event: ROUTE_CHANGE,
            payload: {
                category: 'Navigation',
                action: `Route Change to ${
                    action.payload.location
                        ? action.payload.location.pathname
                        : ''
                }`
            }
        })
    } else {
        window.dataLayer.push({
            event: action.type,
            payload: action.meta ? action.meta.googleAnalytics : ''
        })
    }
    return next(action)
}

export default analytics



// WEBPACK FOOTER //
// ./src/gaMiddleware.js